import React from 'react';
import cx from 'classnames';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import Button from '@material-ui/core/Button';

import { ContextBlock } from './ChangesetRow';

import { CHANNEL_VARIANTS_LABEL, CONTEXT_GROUPS } from '../../constants';
const { INCLUDE, EXCLUDE } = CONTEXT_GROUPS;

export const ChannelHistoryDetails = ({ history, setSelected }) => (
  <div className="w-full h-full">
    <Button
      size="small"
      variant="outlined"
      color="primary"
      style={{ position: 'absolute', right: '1rem' }}
      onClick={() => setSelected(null)}>
      Back to list
    </Button>

    <table className="text-left w-full border-collapse bg-white table-fixed">
      <thead>
        <tr>
          <th className="p-2 font-normal w-32">Updated By</th>
          <th className="p-2 font-normal w-32">Updated On</th>
          <th className="p-2 font-normal w-24">Type</th>
          <th className="p-2 font-normal w-24">Variant</th>
          <th className="p-2 font-normal">Config</th>
        </tr>
      </thead>
      <tbody>
        <tr
          className={cx('b-2-white', {
            'bg-lightYellow': history.operation_type === 'UPDATE',
            'bg-lightGreen': history.operation_type === 'CREATE',
            'bg-lightRed': history.operation_type === 'DELETE',
          })}>
          <td className="p-2">{history.modified_by}</td>
          <td className="p-2">
            {format(parseISO(history.modified_at), 'd MMM yyyy')}
          </td>
          <td className="p-2">{history.type}</td>
          <td className="p-2">{CHANNEL_VARIANTS_LABEL[history.variant]}</td>
          <td className="p-2 text-sm">
            <div className="flex">
              <div className="w-48">
                <strong>Name:</strong>
              </div>
              <div>{history.name}</div>
            </div>
            <div className="flex mt-2">
              <div className="w-48">
                <strong>Status:</strong>
              </div>
              <div>{history.online ? 'Online' : 'Offline'}</div>
            </div>
            <div className="flex mt-2">
              <div className="w-48">
                <strong>Channel display name:</strong>
              </div>
              <div>{history.display_name}</div>
            </div>
            <div className="flex mt-2">
              <div className="w-48">
                <strong>Show offline state:</strong>
              </div>
              <div>{history.show_offline_state ? 'Yes' : 'No'}</div>
            </div>
            <div className="flex mt-2">
              <div className="w-48">
                <strong>Channel button text:</strong>
              </div>
              <div>{history.channel_button_text}</div>
            </div>
            <div className="flex mt-2">
              <div className="w-48">
                <strong>Channel button down text:</strong>
              </div>
              <div>{history.channel_down_text}</div>
            </div>
            <div className="flex mt-2">
              <div className="w-48">
                <strong>Destination:</strong>
              </div>
              <div>{history.destination}</div>
            </div>
            <div className="flex mt-2">
              <div className="w-48">
                <strong>Channel primary description:</strong>
              </div>
              <div
                className="flex-1"
                dangerouslySetInnerHTML={{
                  __html: history.primary_description,
                }}
              />
            </div>
            <div className="flex mt-2">
              <div className="w-48">
                <strong>Channel secondary description:</strong>
              </div>
              <div
                className="flex-1"
                dangerouslySetInnerHTML={{
                  __html: history.secondary_description,
                }}
              />
            </div>
            <div className="flex mt-2">
              <div className="w-48">
                <strong>Opening hour:</strong>
              </div>
              <div className="flex-1">{history.opening_hour.name}</div>
            </div>
            <ContextBlock contextData={history[INCLUDE]} inclusion />
            <ContextBlock contextData={history[EXCLUDE]} inclusion={false} />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
);
